import React from "react";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton, ModalSecondaryButton } from "../..";
import { ModalClose } from "@bcm-dev/bcms-vite";
import "./styles.css";
/**
 * @function CancelBalanceTransferModal
 * @return {React.Component}
 * @exported true
 * @description The main component for CancelBalanceTransferModal
 */
export default function CancelBalanceTransferModal(props) {
    const yesClicked = evt => {
        props.data.yesClicked();
    }
    return (
        <CustomModal className="cancel-balance-transfer-modal" id="CancelBalanceTransferModal">
            <CustomModalContent>
                <p className="text-center">Do you want to cancel the balance transfer request?</p>
            </CustomModalContent>
            <CustomModalFooter className="button-container">
                <ModalPrimaryButton text="Yes" id="CancelBalanceTransferModal" onClick={ yesClicked } />
                {/*<ModalSecondaryButton text="No" />*/}
                <ModalClose id="CancelBalanceTransferModal">
                    <ModalSecondaryButton text="No" />
                </ModalClose>
            </CustomModalFooter>
        </CustomModal>
    )
}
